import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { toast } from 'sonner';
export function Workshops() {
  const [filter, setFilter] = useState('All');
  const filters = ['All', 'Cooking', 'Cultural', 'Professional'];
  const workshops = [{
    id: 4,
    category: ['Cooking'],
    date: 'Tue Sept 22',
    time: '6–8 PM',
    title: 'Let\'s Make Granola',
    instructor: 'Joey Bottary',
    blurb: 'Join Barley-Sane Granola Baker Joey Bottary for a hands-on workshop. Learn three crowd-pleasing variations, from classic oat to grain-free and his signature baked barley flake version. Discover how easy it is to customize flavors and make beautiful batches at home.',
    price: 'Free',
    link: 'https://www.eventbrite.com/e/1998652586689?aff=oddtdtcreator',
    cta: 'Register on Eventbrite'
  }, {
    id: 5,
    category: ['Cooking'],
    date: 'Tue Sept 29',
    time: '6–8 PM',
    title: 'How to make Risotto',
    instructor: 'Chef Manuel Quintero',
    blurb: 'Join Chef Manny of Side A for a hands-on risotto workshop. Learn the techniques behind achieving that perfect creamy texture, how to build layers of flavor, and how to make a dish that feels elegant and effortlessly at home.',
    price: 'Free',
    link: 'https://www.eventbrite.com/e/lets-make-risotto-with-chef-manuel-quintero-tickets-1999054550975',
    cta: 'Register on Eventbrite'
  }, {
    id: 2,
    category: ['Professional'],
    date: 'Mon November 9',
    time: '9 AM – 3 PM',
    title: 'Food Protection Manager Certification',
    instructor: 'Certified Instructor',
    blurb: 'Earn your accredited Food Protection Manager Certification. This course covers safe food handling, storage, and preparation, and includes the certification exam — ideal for vendors, chefs, and food entrepreneurs.',
    price: 'Free',
    note: 'Limited availability',
    cta: 'Register on Eventbrite',
    link: 'https://www.eventbrite.com/e/food-protection-manager-certification-course-exam-tickets-1998019092892'
  }];
  const filteredWorkshops = filter === 'All' ? workshops : workshops.filter(w => w.category.includes(filter));
  const handleReserve = () => {
    toast.success('Spot reserved! Check your email for details.');
  };
  return <section id="workshops" className="py-20 lg:py-32 bg-foodCard border-y-4 border-foodMaroon relative overflow-hidden" data-id="element-259" data-mp="1dlurp06hbkrt">
      {/* Decorative background element */}

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-260" data-mp="1nfk0q2q7oh9u">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-6" data-id="element-261" data-mp="21cqflm7tdvts">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="max-w-2xl" data-id="element-262" data-mp="1wfgtogjmw2ap">
            <h2 className="text-5xl md:text-6xl font-extrabold uppercase mb-4" data-id="element-263" data-mp="2dnzv5pmzhjnv">
              September Workshops & <span className="text-foodGold" data-id="element-264" data-mp="2im1b41p452v4">Classes</span>
            </h2>
            <p className="text-xl font-medium" data-id="element-265" data-mp="23wn6f6whf9m2">
              Roll up your sleeves this September. Every workshop is a free community
              experience — learn new skills, connect with neighbors, and eat
              what you make.
            </p>
          </motion.div>

          {/* Filters */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="flex flex-wrap gap-2" data-id="element-266" data-mp="1zwussfs8ed9u">
            {filters.map(f => <button key={f} onClick={() => setFilter(f)} className={`px-4 py-2 font-bold border-2 border-foodMaroon transition-all ${filter === f ? 'bg-foodMaroon text-foodCream shadow-[2px_2px_0px_0px_#9C3A28]' : 'bg-foodCream text-foodMaroon hover:bg-foodGold hover:shadow-[2px_2px_0px_0px_#34302A]'}`} data-id="element-267" data-mp="3kby1xuemd0pc">
                {f}
              </button>)}
          </motion.div>
        </div>

        {/* Grid */}
        <motion.div layout className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-268" data-mp="16c9z0s28289o">
          <AnimatePresence data-id="element-269" data-mp="11c44n44ki7nw">
            {filteredWorkshops.map(workshop => <motion.div layout initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} exit={{
            opacity: 0,
            scale: 0.9
          }} transition={{
            duration: 0.3
          }} key={workshop.id} className="bg-foodCream border-4 border-foodMaroon p-6 flex flex-col h-full hover:-translate-y-2 hover:border-foodOrange hover:shadow-[8px_8px_0px_0px_#34302A] transition-all duration-300 group" data-id="element-270" data-mp="wjb1ulsnt9eg">
                <div className="flex justify-between items-start mb-4" data-id="element-271" data-mp="dg0rc7letbzq">
                  <div className="flex flex-col gap-1" data-id="element-272" data-mp="idj3s7ymy9ch">
                    <span className="bg-foodOrange text-white font-bold px-3 py-1 text-sm border-2 border-foodMaroon rotate-[-2deg] w-fit" data-id="element-273" data-mp="ic7xa0dt2nho">
                      {workshop.date}
                    </span>
                    <span className="text-foodMaroon/60 font-bold text-xs uppercase tracking-wider pl-1" data-id="element-274" data-mp="3qudy2z1daley">
                      {workshop.time}
                    </span>
                  </div>
                  <div className="flex flex-col items-end" data-id="element-275" data-mp="3vmx6zip40sdf">
                    <span className="font-display font-bold text-xl text-foodTomato uppercase" data-id="element-276" data-mp="2y56zk01wxvtp">
                      {workshop.price}
                    </span>
                    {workshop.note && <span className="text-[11px] font-medium text-foodMaroon/60 italic mt-0.5" data-id="element-277" data-mp="2v2izmeqrb9av">
                        {workshop.note}
                      </span>}
                  </div>
                </div>

                <h3 className="text-2xl font-extrabold uppercase mb-2 group-hover:text-foodOrange transition-colors" data-id="element-278" data-mp="2zutyde9rgp1u">
                  {workshop.title}
                </h3>
                <p className="text-foodMaroon/60 font-bold text-sm mb-4 uppercase tracking-wider" data-id="element-279" data-mp="2c5hqqiu30p1n">
                  with {workshop.instructor}
                </p>
                <p className="mb-8 flex-grow font-medium" data-id="element-280" data-mp="2m4gqtd0s7cd1">{workshop.blurb}</p>

                {workshop.link ? <a href={workshop.link} target="_blank" rel="noopener noreferrer" className="block w-full text-center bg-transparent border-4 border-foodMaroon text-foodMaroon font-bold py-3 hover:bg-foodMaroon hover:text-foodCream transition-colors mt-auto" data-id="element-281" data-mp="2h3jc5aezd0ga">
                    {workshop.cta || 'Reserve Free Spot'}
                  </a> : <button onClick={handleReserve} className="w-full bg-transparent border-4 border-foodMaroon text-foodMaroon font-bold py-3 hover:bg-foodMaroon hover:text-foodCream transition-colors mt-auto" data-id="element-282" data-mp="3r2u4r2kjgg9x">
                    {workshop.cta || 'Reserve Free Spot'}
                  </button>}
              </motion.div>)}
          </AnimatePresence>
        </motion.div>

        {filteredWorkshops.length === 0 && <div className="text-center py-20" data-id="element-283" data-mp="hwvw8imkpnj1">
            <p className="text-2xl font-bold text-foodMaroon/50" data-id="element-284" data-mp="hvks2hp7udre">
              No workshops found for this category.
            </p>
          </div>}
      </div>
    </section>;
}